export default __webpack_public_path__ + "static/media/new-dark.db31e20d.svg";